
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpErrorHandler, HandleError } from "../http-error-handler.service";

import { Config } from "../config";
import { DewAuthService } from "src/authentication/core/auth.service";

const mimeTypes = {
  pdf: "application/pdf",
  png: "image/png",
  jpeg: "image/jpeg",
  bmp: "image/bmp",
  ppm: "image/x-portable-pixmap",
  gif: "image/gif"
};

@Injectable({
  providedIn: "root"
})
export class ApiDocument {
  private handleError: HandleError;
  private httpOption = null;
  private httpOptions = null;
  constructor(
    private http: HttpClient,
    private authService: DewAuthService,
    httpErrorHandler: HttpErrorHandler,
    private sanitizer: DomSanitizer
  ) {
    this.handleError = httpErrorHandler.createHandleError("ApiService");
    this.httpOption = {
        headers: new HttpHeaders({
          Authorization: this.authService.authToken
        })
      };
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.authService.authToken
      })
    };
  }

  //client-document
  getAllClientDocuments(gridProperties): Observable<any> {
    var url = Config.ServiceBaseUrl + "client/getAllClientDocuments";
    var request: any = {};
    request.gridProperties = gridProperties;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError("getAllClientDocuments", request)));
  }

  downloadDewDocFile(gridProperties): Observable<any> {
    var url = Config.DocumentBaseUrl + "client/downloadDewDocFile";
    var request: any = {};
    request.gridProperties = gridProperties;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError("downloadDewDocFile", request)));
  }

  getClientDocumentByClientId(clientId,status,searchValue, gridProperties): Observable<any> {
    var url = Config.DocumentBaseUrl + "getClientDocumentByClientId";
    var request: any = {};
    request.gridProperties = gridProperties;
    request.clientId = clientId;
    request.status = status;
    request.searchValue = searchValue;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError("getClientDocumentByClientId", request)));
  }

  updateClientDocumentByClientDocumentId(data): Observable<any> {
    var url = Config.DocumentBaseUrl + "updateClientDocumentByClientDocumentId";
    var request: any = {};
    return this.http
      .post(url, data, this.httpOptions)
      .pipe(catchError(this.handleError("updateClientDocumentByClientDocumentId", request)));
  }

  createClientDocument(data): Observable<any> {
    var url = Config.DocumentBaseUrl + "createClientDocument";
    var request: any = {};
    return this.http
      .post(url, data,  this.httpOption)
      .pipe(catchError(this.handleError("uploadDewDocFile", request)));
  }
  uploaddoc(fileToUpload:File , isDewDoc ): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/uploadDewDocFile";
    var request: any = {};
    var fd = new FormData();
    fd.append('file', fileToUpload);
    fd.append('isDewDoc', isDewDoc);

    return this.http
      .post(url, fd,  this.httpOption)
      .pipe(catchError(this.handleError("uploadDewDocFile", request)));
  }
}
